<h1 mat-dialog-title class="custom-dialog-title">Individual Query Record
  <button mat-icon-button class="close-button" (click)="closeModal()">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div mat-dialog-content class="modal-container">
  <div class="modal-container">
    <div class="left-panel">
      <div class="modal-box">
        <h3>Equipment Information</h3>
        <p><strong>Equipment ID:</strong> {{ data.equipment_code }}</p>
        <p><strong>Make:</strong> {{ data.make }}</p>
        <p><strong>Model:</strong> {{ data.model }}</p>
        <p><strong>Serial No. Range:</strong>
          {{ data.model_start_end ? (data.model_start_end.split('#')[1] + '-' + data.model_start_end.split('#')[2]) : 'N/A' }}
        </p>
        <p><strong>PVC:</strong> {{ data.pvc? data.pvc : 'N/A'}}</p>
      </div>

      <div class="modal-box">
        <h3>Query Metadata</h3>
        <p><strong>Region:</strong> {{ data.region }}</p>
        <p><strong>Submitted By:</strong> {{ data.submittedBy }}</p>
        <p><strong>Submitted At:</strong> {{ data.start_timestamp }}</p>
        <p><strong>Response Feedback:</strong> {{ data.response_feedback }}</p>
        <p><strong>Submission ID:</strong> {{ data.user_id }}</p>
      </div>

      <div class="modal-box">
        <h3>Prompt Information</h3>
        <div *ngIf="(equipmentPrompts?.length ?? 0) > 0; else noPrompts">
          <ul>
            <li *ngFor="let prompt of equipmentPrompts; let i = index" class="prompt-item">
              {{ prompt }}
              <button mat-icon-button color="warn" class="custom-remove-button" (click)="removePrompt(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </li>
          </ul>
        </div>
        <ng-template #noPrompts>
          <p>No prompts found for this equipment.</p>
        </ng-template>
      
        <div *ngIf="isAdding" class="add-prompt-input-row">
          <input type="text" [(ngModel)]="newPrompt" placeholder="Enter new prompt" class="prompt-input" />
          <button mat-raised-button color="primary" class="custom-save-button" (click)="saveNewPrompt()">
            <mat-icon>save</mat-icon>
            SAVE CHANGES
          </button>
        </div>
      
        <div *ngIf="!isAdding" class="add-prompt-container">
          <button mat-raised-button color="accent" class="custom-prompt-button" (click)="addPrompt()">
            <mat-icon>add_circle_outline</mat-icon>
            ADD PROMPT
          </button>
        </div>
        <div *ngIf="promptError != ''" class="prompt-error">
          <p>{{promptError}}</p>
        </div>
      </div>      
    </div>

    <div class="right-panel">
      <div class="modal-box large-box">
        <h3>Preview</h3>
        <p><strong>Question:</strong></p>
        <p>{{ data.user_input }}</p>
        <div *ngIf="data.original_response" class="original-response-section">
          <p><strong>Original Response:</strong></p>
          <div class="answer-text original-answer">
            <markdown [data]="data.original_response" />
          </div>
        </div>
        <p><strong>{{ data.original_response ? 'Web AI Response:' : 'Answer:' }}</strong></p>
        <div class="answer-text">
          <markdown [data]="data.response" />
        </div>
        <div *ngIf="resources.length > 0">
          <div
            class="chat-reply-answer-source-file-container"
            *ngFor="let resource of resources; let i = index"
          >
            <p class="chat-reply-answer-source-file-title">
              Source {{ i + 1 | number: '2.0-0' }}:
            </p>
            <mat-card
              appearance="outlined"
              class="chat-reply-answer-source-file-card"
              color="primary"
            >
              <mat-icon class="chat-reply-answer-source-file-card-icon">picture_as_pdf</mat-icon>
              <div class="chat-reply-answer-source-file-card-container">
                <span class="chat-reply-answer-source-file-title">{{ resource.title }}</span>
                <span
                  class="chat-reply-answer-source-file-url"
                  (click)="openPDFModal(resource.url)"
                >View Source</span>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="action-container">
  <div class="action-buttons">
    <button mat-button class="custom-switch-button" (click)="exportToPDF()">
      <mat-icon>description</mat-icon>
      EXPORT TO PDF
    </button>
  </div>
</div>